module.exports = __webpack_public_path__ + "img/selected5-min.ae249b0a.png";